<script>
import PageHeader from "@/components/page-header.vue";
import add from "@/views/pages/Dilfoods/charges/add.vue";
import Layout from "@/views/layouts/main.vue";
import axios from "axios";
import {ChargesPath} from "@/path";
import charges_up_push from "@/views/pages/Dilfoods/charges/charges_up_push.vue";

export default {
  components: {charges_up_push, Layout, add, PageHeader},
  data(){
    return {
      title: "Charges",
      items: [
        {
          text: "List",
        },
        {
          text: "Charge",
          active: true,
        },
      ],
      selectedCharge : null,
      base_url : process.env.VUE_APP_API_BACKEND_URL,
      charges : [],
      fields : ["title","description","structure","fulfillment_modes","excluded_platforms","actions"],
      key : 0,
      filter: [],
    }
  },
  mounted() {
    this.getCharges();
  },
  methods : {
    reload(){
      this.getCharges();
    },
    setEdit(v){
      this.addModifier();
      this.selectedCharge = v;
      this.key +=1;
    },
    addModifier(){
      this.$bvModal.show('bv-add-charge');
    },
    uploadToUP(v){
      this.selectedCharge = v;
      this.key +=1;
      this.$bvModal.show('bv-upload-charge');
    },
    async deleteData(v){
      try {
        let res = await axios.delete(this.base_url + ChargesPath.ALL + '/' + v.id);
        if(res.data.status){
          this.reload();
        }
      }catch (e) {
        console.log(e);
      }
    },
    async getCharges(){
      try {
        let res = await axios.get(this.base_url  + ChargesPath.ALL);
        if(res.data.status){
          this.charges = res.data.data;
        }
      }catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button @click="addModifier()" class="btn btn-primary mb-10 pb-10">Add Charges</b-button>
                <b-modal id="bv-add-charge" :title="(selectedCharge && Object.keys(selectedCharge).length > 0 ? 'Edit' : 'Add') + ' Charge'" hide-footer>
                  <add @update="reload()" :key="key" :selected_charge="selectedCharge"></add>
                </b-modal>
                <b-modal id="bv-upload-charge" title="Upload to urban piper" hide-footer>
                  <charges_up_push :key="key" :opg="selectedCharge"></charges_up_push>
                </b-modal>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                  :key="charges.key"
                  :items="charges.data"
                  :fields="fields"
                  responsive="sm"
                  :per-page="charges.per_page"
                  :filter="filter"
                  :current-page="charges.current_page"
              >
                <template v-slot:cell(structure)="row">
                  <ul v-if="row.item.structure">
                    <li>Applicable on : {{row.item.structure.applicable_on}}</li>
                    <li>Value : {{row.item.structure.value}}</li>
                  </ul>
                </template>
                <template v-slot:cell(fulfillment_modes)="row">
                  <b-tag variant="secondary" v-for="(f,fi) in row.item.fulfillment_modes" :key="fi">{{f}}</b-tag>
                </template>
                <template v-slot:cell(excluded_platforms)="row">
                  <b-tag variant="danger" v-for="(f,fi) in row.item.excluded_platforms" :key="fi">{{f}}</b-tag>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button @click="uploadToUP(row.item)" v-b-tooltip.hover title="Update to urban piper" class="mr-2" variant="primary">
                    <i class="fa fa-upload"></i>
                  </b-button>
                  <b-button @click="setEdit(row.item)" variant="primary">
                    <i class="fa fa-pen"></i>
                  </b-button>
                  <b-button @click="deleteData(row.item)" variant="danger" class="ml-1">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination :key="charges.key" v-model="charges.current_page" :total-rows="charges.total" :per-page="charges.per_page"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>

</style>